// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/group_class.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { GroupClassStatus } from "../../enum/v1/group_class_status_pb.js";
import { PaymentCollectionType } from "../../enum/v1/payment_collection_type_pb.js";
import { PageThemeSchema } from "./page_theme_schema_pb.js";
import { Media } from "./media_pb.js";

/**
 * @generated from message fingertip.common.type.v1.GroupClass
 */
export const GroupClass = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.GroupClass",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_at", kind: "message", T: Timestamp },
    { no: 3, name: "updated_at", kind: "message", T: Timestamp },
    { no: 4, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "start_time", kind: "message", T: Timestamp },
    { no: 6, name: "end_time", kind: "message", T: Timestamp },
    { no: 7, name: "max_attendees", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "slots_available", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "booking_policy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "refundable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "cancellation_late_after_date", kind: "message", T: Timestamp },
    { no: 22, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "status", kind: "enum", T: proto3.getEnumType(GroupClassStatus) },
    { no: 24, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "payment_collection_type", kind: "enum", T: proto3.getEnumType(PaymentCollectionType) },
    { no: 26, name: "event_type_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "event_type_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "event_type_length", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 29, name: "last_reminded_at", kind: "message", T: Timestamp },
    { no: 30, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "cancelled_at", kind: "message", T: Timestamp },
    { no: 33, name: "completed_at", kind: "message", T: Timestamp },
    { no: 34, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 35, name: "no_show_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 36, name: "cancellation_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 37, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "waitlist_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 39, name: "theme", kind: "message", T: PageThemeSchema },
    { no: 40, name: "media", kind: "message", T: Media },
    { no: 41, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

